import ChartNoAxesCombined from '../../assests/images/Increase.png';
import Rocket from '../../assests/images/Rocket.png';
import Building from '../../assests/images/Company.png';
import USFlag from '../../assests/images/usFlag.png';
import AustraliaFlag from '../../assests/images/Australia_flag.png';
import BrazilFlag from '../../assests/images/Brazil_flag.png';
import CanadaFlag from '../../assests/images/Canada_flag.png';
import FranceFlag from '../../assests/images/France_flag.png';
import IndiaFlag from '../../assests/images/indiaFlag.jpeg';
import MalaysiaFlag from '../../assests/images/Malaysia_flag.png';
import QatarFlag from '../../assests/images/Qatar_flag.png';
import SingaporeFlag from '../../assests/images/Singapore_flag.png';
import UAEFlag from '../../assests/images/UAE_flag.png';
import ArgentinaFlag from '../../assests/images/Argentina_flag.png';
import ChileFlag from '../../assests/images/Chile_flag.png';
// import IndiaFlag from '../../assests/images/indiaFlag.jpeg';
import GrossSalaryIcon from '../../assests/images/gross-salary.png';
import FederalTaxIcon from '../../assests/images/federal-tax.png';
import StateTaxIcon from '../../assests/images/federal-tax.png';
import FicaIcon from '../../assests/images/fica.png';
import NetTakeHomeIcon from '../../assests/images/federal-tax.png';
import LibertyImage from "../../assests/images/liberty.png";
import Sydney_Opera_House_Image from "../../assests/images/Sydney_Opera_House.png";
import Christ_the_Redeemer_Image from "../../assests/images/Christ_the_Redeemer.png";
import CN_tower_Image from "../../assests/images/CN_tower.png";
import Eiffel_Tower_Image from "../../assests/images/Eiffel_Tower.png";
import Taj_mahal_Image from "../../assests/images/Taj_mahal.png";
import Petronas_Twin_Towers_Image from "../../assests/images/Petronas_Twin_Towers.png";
import Museum_of_Islamic_Art_Image from "../../assests/images/Museum_of_Islamic_Art.png";
import Merlion_Image from "../../assests/images/Merlion.png";
import Burj_Khalifa_Image from "../../assests/images/Burj_Khalifa.png";

import GlobalHiringImage from '../../assests/images/insights_img_1.png';


export const images = {
  ChartNoAxesCombined,
  Rocket,
  Building,
  USFlag,
  AustraliaFlag,
  BrazilFlag,
  CanadaFlag,
  FranceFlag,
  IndiaFlag,
  MalaysiaFlag,
  QatarFlag,
  SingaporeFlag,
  UAEFlag,
  ArgentinaFlag,
  ChileFlag,
  GrossSalaryIcon,
  FederalTaxIcon,
  StateTaxIcon,
  FicaIcon,
  NetTakeHomeIcon,
  LibertyImage,
  Sydney_Opera_House_Image,
  Christ_the_Redeemer_Image,
  CN_tower_Image,
  Eiffel_Tower_Image,
  Taj_mahal_Image,
  Petronas_Twin_Towers_Image,
  Museum_of_Islamic_Art_Image,
  Merlion_Image,
  Burj_Khalifa_Image,
  GlobalHiringImage
};